<template>
  <div class="SectionTitle">
    <span class="hide480 mr-1 text-s text-gray-700 uppercase font-mono">{{
      title
    }}</span>
    <span class="hide480 text-s text-gray-500 font-mono">[</span>
    <span class="text-s text-gray-500 font-mono">{{ num }}</span>
    <span class="hide480 text-s text-gray-500 font-mono">]</span>
    <span
      v-if="numNews > 0"
      v-tooltip="'Unread ' + title"
      class="NumNew relative ml-5 text-xs text-highlight font-sans"
      :class="{'cursor-pointer': clickable}"
      @click="onClick"
    >
      {{ numNews }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'LmSectionTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    num: {
      type: Number,
      default: 0
    },
    numNews: {
      type: Number,
      default: 0
    },
    clickable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick() {
      if (this.clickable) this.$emit('click-new')
    }
  }
}
</script>

<style scoped>
.NumNew:before {
  content: '';
  position: absolute;
  top: 4px;
  left: -8px;
  width: 7px;
  height: 7px;
  background-color: theme('colors.highlight');
  border-radius: 100%;
}
.hide480 {
  @media (max-width: 480px) {
    display: none;
  }
}
</style>
